// src/pages/TrackingPage.jsx
import React, { useEffect, useState, useRef } from 'react';
import io from 'socket.io-client';
import api from '../../../services/api';
import MapComponent from './TrackingMapComponent';
import PopupContent from './PopupContent';
import './TrackingPage.css';

export default function TrackingPage() {
  const socketRef = useRef();
  const [allUsers, setAllUsers] = useState([]);
  const [liveMode, setLiveMode] = useState(true);
  const [liveData, setLiveData] = useState({});
  const [selectedCourier, setSelectedCourier] = useState(null);
  const [dateFrom, setDateFrom] = useState(new Date().toISOString().slice(0,10));
  const [dateTo, setDateTo] = useState(new Date().toISOString().slice(0,10));
  const [historyData, setHistoryData] = useState({});

  // Fetch all couriers
  useEffect(() => {
    async function fetchUsers() {
      try {
        const usersResponse = await api.get('/users');
        setAllUsers(usersResponse || []);
      } catch (err) {
        console.error(err);
      }
    }
    fetchUsers();
  }, []);

  // WebSocket live tracking
  useEffect(() => {
    const socket = io('/ws', { auth: { token: localStorage.getItem('jwt') } });
    socketRef.current = socket;
    if (liveMode) {
      socket.on('courier:location:update', data => {
        setLiveData(prev => ({ ...prev, [data.courierId]: data }));
      });
    }
    return () => {
      socket.off('courier:location:update');
      socket.disconnect();
    };
  }, [liveMode]);

  // Fetch history when selection or dates change
  useEffect(() => {
    if (!selectedCourier) return;
    async function fetchHistory() {
      try {
        const res = await api.get(
          `/users/${selectedCourier}/locations`,
          { params: { from: `${dateFrom}T00:00:00Z`, to: `${dateTo}T23:59:59Z` }}
        );
        setHistoryData(prev => ({ ...prev, [selectedCourier]: res || [] }));
      } catch (err) {
        console.error(err);
      }
    }
    fetchHistory();
  }, [selectedCourier, dateFrom, dateTo]);

  const toggleLive = () => setLiveMode(m => !m);
  const clearHistory = () => {
    setHistoryData({});
    setSelectedCourier(null);
  };

  return (
    <div className="tracking-container">
      <aside className="tracking-sidebar">
        <h2>Управление трекингом</h2>
        <div className="controls">
          <button onClick={toggleLive}>
            {liveMode ? 'Остановить Live' : 'Запустить Live'}
          </button>
          <button onClick={clearHistory}>Сбросить историю</button>
        </div>
        <div className="date-filters">
          <label>
            С:{' '}
            <input
              type="date"
              value={dateFrom}
              onChange={e => setDateFrom(e.target.value)}
            />
          </label>
          <label>
            По:{' '}
            <input
              type="date"
              value={dateTo}
              onChange={e => setDateTo(e.target.value)}
            />
          </label>
        </div>
        <h3>Курьеры</h3>
        <ul className="courier-list">
          {allUsers.map(user => (
            <li key={user.id} className={user.id === selectedCourier ? 'selected' : ''}>
              <button onClick={() => setSelectedCourier(user.id)}>
                {user.firstName} {user.lastName}
              </button>
            </li>
          ))}
        </ul>
      </aside>
      <main className="tracking-main">
        <MapComponent
          center={liveData[selectedCourier] || [50.06,19.94]}
          zoom={13}
          liveData={Object.values(liveData)}
          historyData={selectedCourier ? historyData[selectedCourier] : null}
          allowedUsersLocations={{}}
          PopupContent={PopupContent}
        />
      </main>
    </div>
  );
}